export type TransactionStatsType = "SALARY" | "TRANSFER" | "EXPENSES";
export type TransferMetricKey =
    | "rub_amount"
    | "purchase_amount"
    | "profit_rub"
    | "transfer_amount"
    | "send_amount";
export type TransferTabKey = "OVERALL" | "CURRENCY";

export const periods = [
    { key: "day", label: "за день" },
    { key: "week", label: "за неделю" },
    { key: "month", label: "за месяц" },
    { key: "year", label: "за год" },
    { key: "allTime", label: "за всё время" }
] as const;

export const transferMetricOptions = [
    { value: "rub_amount", name: "сумма в рублях" },
     { value: "purchase_amount", name: "сумма закупки" },
    { value: "profit_rub", name: "прибыль в USDT" },
   // { value: "transfer_amount", name: "сумма перевода" },
    { value: "send_amount", name: "сумма отправки" }
];

export const transferFieldConfig: Record<
    TransferMetricKey,
    {
        overallTitle: string;
        cityTitle: string;
        currencyTitle: string;
        isMoney: boolean;
    }
> = {
    transfer_amount: {
        overallTitle: "Переводы: сумма перевода",
        cityTitle: "Переводы по городам: сумма перевода",
        currencyTitle: "Переводы по валютам: сумма перевода",
        isMoney: false
    },
    send_amount: {
        overallTitle: "Переводы: сумма отправки",
        cityTitle: "Переводы по городам: сумма отправки",
        currencyTitle: "Переводы по валютам: сумма отправки",
        isMoney: false
    },
    rub_amount: {
        overallTitle: "Переводы: сумма в рублях",
        cityTitle: "Переводы по городам: сумма в рублях",
        currencyTitle: "Переводы по валютам: сумма в рублях",
        isMoney: true
    },
    purchase_amount: {
        overallTitle: "Переводы: сумма закупки",
        cityTitle: "Переводы по городам: сумма закупки",
        currencyTitle: "Переводы по валютам: сумма закупки",
        isMoney: false
    },
    profit_rub: {
        overallTitle: "Переводы: прибыль в USDT",
        cityTitle: "Переводы по городам: прибыль в USDT",
        currencyTitle: "Переводы по валютам: прибыль в USDT",
        isMoney: false
    }
};

export const DEBOUNCE_DELAY = 400;
